import { User } from '@/__generated__/graphql';
import { titleCase } from '@/utils';
import { Tooltip, Typography } from '@mui/material';

type Props = { roleIds: User['roleIds'] };

export const RolesCell = ({ roleIds }: Props) => {
  return (
    <>
      {roleIds?.slice(0, 3)?.map((role, index) => (
        <Typography key={role?.id} component="span" fontSize="1.4rem" fontWeight={500}>
          {titleCase(role?.name)}
          {index < roleIds.length - 1 ? ', ' : ''}
        </Typography>
      ))}
      {roleIds.length > 3 && (
        <Tooltip
          title={roleIds
            .slice(3)
            .map((role) => role?.name)
            .join(', ')}
        >
          <Typography component="span" fontSize="1.4rem" fontWeight={500}>
            {` +${roleIds.length - 3}`}
          </Typography>
        </Tooltip>
      )}
    </>
  );
};
